// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const hedgehog = defineModel({
  id: "hedgehog",
  batchId: "standard",
  name: "Hedgehog",
  tags: ["creature","hedgehog","low-poly","age-of-mcp","classic"],
  summary: "Low-poly hedgehog.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.026, 0), color: "#6b5a44", position: [0, 0.022, 0], scale: [1.2, 0.9, 1] },
      { geometry: new THREE.ConeGeometry(0.014, 0.026, 5), color: "#caa478", position: [0.03, 0.016, 0], rotation: [0, 0, -1.570796] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#1c1610", position: [0.04, 0.02, 0] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [0.012, 0.04, 0], rotation: [0, 0, 0.048] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [-0.014, 0.038, 0], rotation: [0, 0, -0.056] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [0, 0.046, 0] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [0.018, 0.03, 0], rotation: [0, 0, 0.072] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [-0.02, 0.028, 0], rotation: [0, 0, -0.08] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [0.008, 0.042, 0], rotation: [0, 0, 0.032] },
      { geometry: new THREE.ConeGeometry(0.005, 0.018, 4), color: "#3e3327", position: [-0.006, 0.044, 0], rotation: [0, 0, -0.024] },
    ],
  animations: [],
});
